var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        'textTransform-uppercase': {
            textTransform: 'uppercase',
        },
        'textTransform-none': {
            textTransform: 'none',
        },
        'overflow-visible': {
            overflow: 'hidden',
            whiteSpace: 'initial',
        },
        'overflow-initial': {
            overflow: 'hidden',
            textOverflow: 'initial',
        },
        'overflow-ellipsis': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        'overflow-clip': {
            overflow: 'hidden',
            textOverflow: 'clip',
        },
        'color-default': {
            color: theme.palette.grey[700],
        },
        'color-primary': {
            color: theme.palette.primary.main,
        },
        'color-muted': {
            color: theme.palette.grey[500],
        },
        'color-mint': {
            color: theme.palette.secondary.main,
        },
        'color-error': {
            color: theme.palette.error.main,
        },
        'color-white': {
            color: theme.palette.white.main,
        },
        h1: (_a = {
                fontWeight: 'bold',
                fontSize: '1.5rem',
                lineHeight: 1.20588
            },
            _a[theme.breakpoints.up('md')] = {
                fontSize: '1.875rem',
            },
            _a),
        h1Light: (_b = {
                color: theme.palette.grey[500],
                fontSize: '1.5rem',
                lineHeight: 1.20588
            },
            _b[theme.breakpoints.up('md')] = {
                fontSize: '1.875rem',
            },
            _b),
        ch1: (_c = {
                fontWeight: 'bold',
                fontSize: '1.5rem'
            },
            _c[theme.breakpoints.up('md')] = {
                fontSize: '1.875rem',
            },
            _c.color = theme.palette.white.main,
            _c.backgroundColor = theme.palette.grey[700],
            _c.padding = '1rem',
            _c),
        h2: (_d = {
                fontWeight: 'bold',
                fontSize: '1.125rem',
                lineHeight: 1.35417
            },
            _d[theme.breakpoints.up('md')] = {
                fontSize: '1.5rem',
            },
            _d),
        h3: (_e = {
                fontWeight: 'bold',
                fontSize: '1rem',
                lineHeight: 1.16667
            },
            _e[theme.breakpoints.up('md')] = {
                fontSize: '1.25rem',
            },
            _e),
        h4: (_f = {
                fontWeight: 'bold',
                fontSize: '0.875rem',
                lineHeight: 1.5
            },
            _f[theme.breakpoints.up('md')] = {
                fontSize: '1.125rem',
            },
            _f),
        paragraphTitle: {
            fontWeight: 'bold',
            fontSize: '1rem',
            lineHeight: '1.625rem',
        },
        paragraph: {
            fontWeight: 'normal',
            fontSize: '1rem',
            lineHeight: 1.5,
        },
        caption: {
            fontWeight: 'normal',
            fontSize: '0.875rem',
            lineHeight: 1.375,
        },
        helper: {
            fontWeight: 'normal',
            fontSize: '0.75rem',
            lineHeight: 1.333,
        },
        button: {
            fontWeight: 'normal',
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            lineHeight: 1.5,
        },
        // last to overwrite if needed
        'fontWeight-normal': {
            fontWeight: 'normal',
        },
        'fontWeight-bold': {
            fontWeight: 'bold',
        },
        'lineHeight-1': {
            lineHeight: 1,
        },
    });
});
var MuiTypography = function (props) { return React.createElement(Typography, __assign({}, props)); };
// Typography: https://housinganywhere.atlassian.net/wiki/spaces/DS/pages/914489352/Typography
// Description: This component is in charge of setting up predifined styles from DSL and
// allowing you to choose between default and muted color text.
var CustomTypography = function (_a) {
    var className = _a.className, textTransform = _a.textTransform, fontWeight = _a.fontWeight, children = _a.children, noWrap = _a.noWrap, component = _a.component, variant = _a.variant, ownVariant = _a.ownVariant, _b = _a.color, color = _b === void 0 ? 'default' : _b, _c = _a.overflow, overflow = _c === void 0 ? 'initial' : _c, _d = _a.display, display = _d === void 0 ? 'block' : _d, lineHeight = _a.lineHeight, align = _a.align, rest = __rest(_a, ["className", "textTransform", "fontWeight", "children", "noWrap", "component", "variant", "ownVariant", "color", "overflow", "display", "lineHeight", "align"]);
    var classes = useStyles();
    return (React.createElement(MuiTypography, __assign({ className: cx(className, classes[ownVariant], classes["overflow-" + overflow], classes["color-" + color], classes["textTransform-" + textTransform], classes["fontWeight-" + fontWeight], classes["lineHeight-" + lineHeight]), component: component, noWrap: overflow !== 'visible' &&
            (noWrap || overflow === 'ellipsis' || overflow === 'clip'), variant: variant, align: align, display: display }, rest), children));
};
function make(variant, ownVariant) {
    var TypographyNext = function (props) { return (React.createElement(CustomTypography, __assign({}, props, { variant: variant, ownVariant: ownVariant }))); };
    TypographyNext.displayName = "Typography." + ownVariant;
    return TypographyNext;
}
export var TypographyTypes;
(function (TypographyTypes) {
    TypographyTypes["Button"] = "Button";
    TypographyTypes["Caption"] = "Caption";
    TypographyTypes["CH1"] = "CH1";
    TypographyTypes["H1"] = "H1";
    TypographyTypes["H1Light"] = "H1Light";
    TypographyTypes["H2"] = "H2";
    TypographyTypes["H3"] = "H3";
    TypographyTypes["H4"] = "H4";
    TypographyTypes["H5"] = "H5";
    TypographyTypes["H6"] = "H6";
    TypographyTypes["HelperText"] = "HelperText";
    TypographyTypes["Paragraph"] = "Paragraph";
    TypographyTypes["ParagraphTitle"] = "ParagraphTitle";
})(TypographyTypes || (TypographyTypes = {}));
// We expose different typographies through Typography component
// so you can use Typography.Variant
// Different styles can be applied in the future altough right now
// it is about color, but we could manage font size by breakpoints.
export default (_a = {},
    _a[TypographyTypes.Button] = make('button', 'button'),
    _a[TypographyTypes.Caption] = make('caption', 'caption'),
    _a[TypographyTypes.CH1] = make('h1', 'ch1'),
    _a[TypographyTypes.H1] = make('h1', 'h1'),
    _a[TypographyTypes.H1Light] = make('h1', 'h1Light'),
    _a[TypographyTypes.H2] = make('h2', 'h2'),
    _a[TypographyTypes.H3] = make('h3', 'h3'),
    _a[TypographyTypes.H4] = make('h4', 'h4'),
    _a[TypographyTypes.H5] = make('h5', 'h5'),
    _a[TypographyTypes.H6] = make('h6', 'h6'),
    _a[TypographyTypes.HelperText] = make('caption', 'helper'),
    _a[TypographyTypes.Paragraph] = make('body1', 'paragraph'),
    _a[TypographyTypes.ParagraphTitle] = make('body2', 'paragraphTitle'),
    _a);
//# sourceMappingURL=Typography.js.map